module.exports = __webpack_public_path__ + "static/media/sell_request_details_help_1.07c3f343.png";